import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useBoardingModuleVisible } from '../hooks/useBoardingModuleVisible';

const PrivateNotFoundPage: React.FC = () => {
  const { t } = useTranslation(['navigation', 'sidebar']);
  const boardingModuleVisible = useBoardingModuleVisible();

  return (
    <div style={{ padding: '48px 24px', maxWidth: 560, margin: '0 auto', textAlign: 'center' }}>
      <Typography variant="h5" component="h3" gutterBottom>
        {t('navigation:privateNotFoundPage.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        {t('navigation:privateNotFoundPage.description')}
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="center">
        <Button component={Link} to="/app" variant="contained" color="primary" sx={{ textTransform: 'none' }}>
          {t('sidebar:menu.home')}
        </Button>
        {boardingModuleVisible && (
          <Button component={Link} to="/app/pension" variant="outlined" sx={{ textTransform: 'none' }}>
            {t('sidebar:menu.pension')}
          </Button>
        )}
        <Button component={Link} to="/app/reservations" variant="outlined" sx={{ textTransform: 'none' }}>
          {t('sidebar:menu.reservations')}
        </Button>
      </Stack>
    </div>
  );
};

export default PrivateNotFoundPage;
